export const DrawerPlacement = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
} as const;
